export default {
    setUser: (context: any, newVal: any): void => {
        context.commit('setUser', newVal);
    }
};
